export default function InstructorFocusToday({ progression }) {
  const focusItems = progression?.session_focus?.suggested_focus_today || [];
  if (!focusItems.length) return null;

  return (
    <section className="audit-focus-panel" aria-label="Suggested focus today" data-testid="instructor-teach-today">
      <div className="audit-panel-header" style={{ marginBottom: "0.75rem" }}>
        <h2 className="audit-section-title">Focus today</h2>
      </div>
      <div className="flex flex-wrap gap-2">
        {focusItems.map((label) => (
          <span key={label} className="audit-focus-chip">
            {label}
          </span>
        ))}
      </div>
    </section>
  );
}
